
export type TerminalDeviceType = 'misconfigured' | 'phone' | 'softPhone' | 'external' | 'combined'

export type TerminalStatus = 'noControl' | 'connected' | 'notConnected'
export interface Terminal {
  guid: string,
  id: number,
  loginForDisplay: string,
  description: string,
  macAddress: string,
  deviceName: string,
  deviceType: TerminalDeviceType,
  status: TerminalStatus,
  ipAddress: string,
  externalPhoneNumber: string,
  isRtuClient: boolean,
  isWebClient: boolean,
  maxEquipmentLines: number,
  enabledReceivingCall: boolean
}

export type TerminalFieldsKeys = keyof Terminal

export type TerminalFields = {
  [key in TerminalFieldsKeys]?: string
}

export interface TerminalFieldPayload {
  value: string | undefined
  path: TerminalFieldsKeys
  op: string
}

export enum OutgoingCallsHandlingConditions {
  ASK = 'alwaysAsk',
  DEFAULT = 'byDefault',
}
